









import Vue from 'vue';
export default Vue.extend({
    name: 'DvError',
    props: {
        message: { type: String, default: 'Something went wrong.' },
        detail: { type: String, default: '' },
        iconClass: { type: String, default: 'fa-exclamation-triangle' },
        canRetry: { type: Boolean, default: false },
    },
});
